import React,{useState, useEffect, useRef} from 'react';
import {
    Button, InputGroup, InputGroupText,
    Card,Badge,Spinner,
    CardHeader, Modal, ModalHeader, ModalBody, Table,
    CardBody,
    CardFooter,
    CardTitle,
    FormGroup,
    Form,
    Input,
    Row,
    Col,
    Container,
  } from "reactstrap";
  import ReactTable from "components/ReactTable/ReactTable.js";
  import Select from "react-select";
  import {customStyles} from '../../helpers/mycomps'

  function VfeatureTab(props) {
    
     let data = props.featuresList.map((x, key) => {
                  
                    return {
                        key : key,
                       // featuresList : x.featuresList,
                        featureCode : x.featureCode,
                        en : x.en,
                        fr : x.fr,
                        ar : x.ar,
                        valueRange : x.valueRange,
                        unit : x.unit,
                        ficon : x.ficon,
                        actions: (
                            <div className="actions-right" styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} id={key}>
                                <Select  styles={customStyles} options = {x.valueRange.map(p => {
                                    return {value : p.vrid , label : p.len}
                                })}
                                onChange={n => {
                                    x.select = n.label
                                    let datan =props.vehicle.features.find(m => m.featureCode === x.featureCode) 
                                    if(!datan){
                                        props.setVehicle({...props.vehicle, features : [...props.vehicle.features, {
                                            key : key,
                                            featureCode : x.featureCode,
                                            en : x.en,
                                            fr : x.fr,
                                            ar : x.ar,
                                            unit : x.unit,
                                            ficon : x.ficon,
                                            rangevalueL : n.label
                                        }]})  
                                    }else{
                                        let fet = props.vehicle.features
                                        fet.find(m => m.featureCode === x.featureCode).rangevalueL = n.label
                                        console.log(fet)
                                        props.setVehicle({...props.vehicle, features : fet})

                                    }
                                }}
                                value={{value : "0" , label : checkedifv(x.featureCode)}}
                              />
                             </div>
                          ),
                    }
                    
                })
            
   const closeBox = () => {
      //  props.setVehicle({...props.vehicle, features : props.features})
        props.setShowft(false)
   }




   const checkedis = (condition) => {
      let result = props.vehicle.features.find(m => m.featureCode === condition)
    return result   
   }


   function checkedifv (condition) {
    let result = "0"
    try{
        result= props.vehicle.features.find(m => m.featureCode === condition).rangevalueL
    }catch (e)
    {
        result = "0"
    }
    return result
   }

    return (
        <Modal isOpen={props.showft} className="modal-xl" style={{marginTop : -30}}>
           
            <ModalHeader  className="align-middle" >
            <span >Category Features for {props.vehicle.category.en}</span>
            <i className="fa fa-times" style={{float : "right", cursor: "pointer"}} onClick={x => closeBox()} aria-hidden="true"></i>     
            </ModalHeader>
            <ModalBody>
                    <div className="content">
                        <Row>
                        <Col md="12">
                            <Card>
                           
                            <CardBody>
                                <Table>
                                    <thead>
                                        <tr>
                                            <th><i className="fa fa-square-o" aria-hidden="true"></i></th>
                                            <th>Icon</th>
                                            <th>Feature</th>
                                            <th>Value</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data.map((g,key) => {
                                            return (
                                                <tr key={key}>
                                                    <td  style={{ textAlign : "center" }}><span style={{paddingTop : -20}}>{<Input type="checkbox" style={{marginTop : -5}} 
                                                    checked={ checkedis(g.featureCode)} 
                                                   // disabled={props.features.find(m => m.featureCode !== g.featureCode)}
                                                    onChange={op => {
                                                        
                                                        if( props.vehicle.features.find(m => m.featureCode === g.featureCode)){
                                                            console.log("Found it")
                                                            props.setVehicle({...props.vehicle, features : props.vehicle.features.filter(i => i.featureCode !== g.featureCode)})
                                                            //g,featureCode    
                                                            //     props.setFeatureslist(props.featuresList.filter(i => i.featureCode !== g.featureCode))
                                                        }else{
                                                            if(!op.target.checked)
                                                            console.log("Please select Value from list")
                                                            op.target.checked = false
                                                        }
                                                    }}    
                                                    
                                                    />}</span> </td>
                                                    <td>{<img alt="..." width={"30px"} src={`${g.ficon}`} style={{ cursor : "pointer"}} /> }</td>
                                                    <td>{g.en   + " - " + g.ar}</td>
                                                    <td>{g.actions}</td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </Table>
                        {/** With Driver / Without driver */}
                             </CardBody>
                            </Card>
                        </Col>
                        </Row>
            </div>
            </ModalBody>
        </Modal>
    );
}

export default VfeatureTab;